import { styled } from '@mui/material/styles';
import { 
  Menu,
  MenuItem,
  Box,
  Badge,
  alpha
} from '@mui/material';

export const StyledMenu = styled(Menu)(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: theme.spacing(2),
    marginTop: theme.spacing(1),
    minWidth: 380,
    maxWidth: 420,
    maxHeight: 600,
    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      display: 'block',
      position: 'absolute',
      top: 0,
      right: 24,
      width: 12,
      height: 12,
      bgcolor: 'background.paper',
      transform: 'translateY(-50%) rotate(45deg)',
      zIndex: 0,
      boxShadow: '-3px -3px 5px rgba(0,0,0,0.04)',
    },
  },
}));

export const NotificationHeader = styled(Box)(({ theme }) => ({
  background: theme.palette.mode === 'dark' 
    ? `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.15)} 0%, ${alpha(theme.palette.primary.dark, 0.25)} 100%)`
    : `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  color: theme.palette.mode === 'dark' ? theme.palette.text.primary : 'white',
  padding: theme.spacing(2, 3),
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderBottom: `1px solid ${alpha(theme.palette.divider, 0.1)}`,
}));

export const NotificationItem = styled(MenuItem)(({ theme }) => ({
  padding: theme.spacing(1.5),
  borderRadius: theme.spacing(1),
  margin: theme.spacing(0.5, 1),
  transition: 'all 0.2s ease',
  backgroundColor: theme.palette.mode === 'dark' ? 'transparent' : 'white',
  maxWidth: '100%',
  overflow: 'hidden',
  minHeight: 'auto',
  height: 'auto',
  whiteSpace: 'normal',
  '&:hover': {
    backgroundColor: theme.palette.mode === 'dark' 
      ? alpha(theme.palette.primary.main, 0.15)
      : alpha(theme.palette.primary.main, 0.08),
    transform: 'translateX(2px)',
  },
  '&.unread': {
    backgroundColor: theme.palette.mode === 'dark'
      ? alpha(theme.palette.primary.main, 0.08)
      : alpha(theme.palette.primary.main, 0.04),
    borderLeft: `3px solid ${theme.palette.primary.main}`,
    paddingLeft: `calc(${theme.spacing(1.5)} - 3px)`, // Compensar a borda
  },
}));

export const StyledBadge = styled(Badge)(({ theme }) => ({
  '& .MuiBadge-badge': {
    right: -8,
    top: -8,
    padding: '0 4px',
    height: 18,
    minWidth: 18,
    fontSize: '0.75rem',
    animation: 'pulse 2s infinite',
    '@keyframes pulse': {
      '0%': {
        transform: 'scale(1)',
        boxShadow: '0 0 0 0 rgba(255, 0, 0, 0.7)',
      },
      '70%': {
        transform: 'scale(1.1)',
        boxShadow: '0 0 0 6px rgba(255, 0, 0, 0)',
      },
      '100%': {
        transform: 'scale(1)',
        boxShadow: '0 0 0 0 rgba(255, 0, 0, 0)',
      },
    },
  },
}));

export const EmptyStateContainer = styled(Box)(({ theme }) => ({
  padding: theme.spacing(8, 2),
  textAlign: 'center',
  '& .MuiSvgIcon-root': {
    fontSize: 64,
    color: theme.palette.text.disabled,
    marginBottom: theme.spacing(2),
    opacity: 0.5,
  },
}));

export const NotificationContent = styled(Box)(({ theme }) => ({
  maxHeight: 450,
  overflow: 'auto',
  padding: theme.spacing(1, 0),
  '&::-webkit-scrollbar': {
    width: 8,
  },
  '&::-webkit-scrollbar-track': {
    background: 'transparent',
  },
  '&::-webkit-scrollbar-thumb': {
    background: theme.palette.divider,
    borderRadius: 4,
    '&:hover': {
      background: theme.palette.action.disabled,
    },
  },
}));
